import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

/**
 * this custom translation loade will treat null as empty string
 * "sliderText" : null      =       "sliderText": ""
 */
export class CustomTranslationLoader implements TranslateLoader {
  constructor(private http: HttpClient, private prefix: string = '/assets/i18n/', private suffix: string = '.json') {}

  /* istanbul ignore next reason: not required because we mock it on TranslateLoaderMock*/
  public getTranslation(lang: string) {
    return this.http.get(`${this.prefix}${lang}${this.suffix}`).pipe(map(res => this.process(res)));
  }

  public process(object) {
    const newObject = {};

    for (const key in object) {
      /* istanbul ignore else reason: not required*/
      if (object.hasOwnProperty(key)) {
        if (object[key] === null) {
          newObject[key] = '';
        } else if (typeof object[key] === 'object') {
          newObject[key] = this.process(object[key]);
        } else {
          newObject[key] = object[key];
        }
      }
    }

    return newObject;
  }
}
